import { HStack } from "@whoosh/design-system/src/components/primitive";
import { Box } from "@whoosh/design-system/src/components/primitive/Box/Box";

import { IconCard } from "./IconCard";

type IconCardStackProps = {
  isMobile: boolean;
  size?: "sm" | "md";
};

export const IconCardStack = ({
  isMobile,
  size = "md",
}: IconCardStackProps) => {
  return (
    <Box
      position={"absolute"}
      top={0}
      left={0}
      height={isMobile ? 80 : "100%"}
      right={0}
      overflow="hidden"
      justifyContent={"center"}
      alignItems={"center"}
    >
      <HStack
        width={size === "sm" ? "auto" : 174}
        position="relative"
        top={isMobile ? 16 : 0}
        style={{ transform: [{ scale: isMobile ? 1 : 0.9 }] }}
      >
        <Box
          style={{
            top: 5,
            position: "relative",
            transform: [
              { rotate: size === "sm" ? "-30deg" : "-15deg" },
              { scale: 0.8 },
            ],
          }}
        >
          <IconCard size={size} />
        </Box>
        <Box style={{ zIndex: 1000, marginLeft: size === "sm" ? -10 : -20 }}>
          <IconCard size={size} />
        </Box>
        <Box
          style={{
            top: 5,
            position: "relative",
            marginLeft: size === "sm" ? -10 : -20,
            transform: [
              { rotate: size === "sm" ? "30deg" : "15deg" },
              { scale: 0.8 },
            ],
          }}
        >
          <IconCard size={size} />
        </Box>
      </HStack>
    </Box>
  );
};
